// Copyright © 2021 React Training LLC. All rights reserved.
function createHtml(html) {
  return {
    __html: html
  };
}

export { createHtml };
